import { CommercialMetricsConfig } from '@tenants';

//FIXME: Use Growthbook to get the correct values
export const metricsConfig: CommercialMetricsConfig = {
  metrics: [
    {
      value: '$185.2B',
      label: 'Transaction Volume',
    },
    {
      value: '$4.6B',
      label: '2024 Revenue',
    },
    {
      value: '434',
      label: 'Transactions',
    },
  ],

  backgroundVideo: {
    src: '/next/assets/images/exp-commercial/metrics-background.mp4',
    type: 'video/mp4',
  },
  logo: {
    src: '/next/assets/images/exp-commercial/eXp-World-Holdings-White.svg',
    alt: 'eXp Logo',
    width: 188,
    height: 40,
  },
};